import React from "react";

const AboutUs = () => {
  return (
    <div className="container m-auto p-4 md:py-6">
      <div className="text-grey-1000 leading-normal">
        <div className="text-justify">
          <div>
            <h2 className="text-2xl font-semibold mb-1 leading-loose">
              About YatraTickets
            </h2>
            <p className="mb-3">
              YatraTickets.com is a trusted and reliable online ticketing platform designed to make your travel booking experience simple, secure, and hassle-free. With over three decades of expertise in the travel industry behind us, we bring you the convenience of booking both domestic and international flights at affordable, competitive prices—anytime, anywhere in the world.

              At YatraTickets.com, we believe travel should be effortless and accessible to everyone. Our platform allows you to find and book flights quickly, compare fares with ease, and secure the best deals available. Beyond flights, we offer a complete range of travel services, including hotel bookings, curated tour packages, and assistance with every detail of your journey.

              Our commitment is to provide transparency, trust, and top-quality customer service—so you can focus on enjoying your trip while we handle the details. Whether you’re planning a quick getaway or a global adventure, YatraTickets.com is your dependable travel companion, helping you explore the world with confidence and comfort.
            </p>

          </div>
          {/* <div>
            <h2 className="text-2xl font-semibold mb-1 leading-loose">
              Our Vision
            </h2>
            <p className="mb-3">
              To make Gandaki Tours &Travels the leading travel and trade
              company in the country by promoting tourism industry of Nepal
              thereby, creating employment,opportunities for locals and
              generating revenue for development.
            </p>
          </div>
          <div>
            <h2 className="text-2xl font-semibold mb-1 leading-loose">
              Our Mission
            </h2>
            <p className="mb-3">
              To provide reliable and quality services to all our valued
              customers according to their need and convenience giving full
              satisfaction with the best value of money they spend.
            </p>
          </div>
          <div>
            <h2 className="text-2xl font-semibold mb-1 leading-loose">
              Membership
            </h2>
            <p className="mb-3">
              To provide reliable and quality services to all our valued
              customers according to their need and convenience giving full
              satisfaction with the best value of money they spend.
            </p>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
